import { all, call, takeEvery, fork } from "redux-saga/effects";
import newRequestFunction from "../Utils/newSGF"

import {
  GET_ALL_REGISTERED_CM_ICA,
  GET_CM_ICA_BY_ID,
  EXPORT_CM_TRAINING,
  GET_ALL_ICA_NO_PAGINATION,
} from "../ActionTypes";

import {
  getAllRegisteredCmSuccessIca,
  getAllRegisteredCmFailureIca,

  getCmIcaByIdSuccess,
  getCmIcaByIdFailure,

  exportCmTrainingSuccess,
  exportCmTrainingFailure,

  getAllIcaNoPaginationSuccess,
  getAllIcaNoPaginationFailure
} from "../Actions";

import {
  getAllRegisteredCmIcaApi,
  getCmIcaByIdApi,
  exportCmTrainingApi,
  getAllIcaNoPaginationApi
} from "../Api"


// Requests

const getAllRegisteredCmIcaRequest = function* ({ payload }) {
  yield call(newRequestFunction, getAllRegisteredCmSuccessIca, getAllRegisteredCmFailureIca, getAllRegisteredCmIcaApi, payload)
}

const getCmIcaRequest = function* ({ payload }) {
  yield call(newRequestFunction, getCmIcaByIdSuccess, getCmIcaByIdFailure, getCmIcaByIdApi, payload)
}


const exportCmTrainingRequest = function* ({ payload }) {
  yield call(newRequestFunction, exportCmTrainingSuccess, exportCmTrainingFailure, exportCmTrainingApi, payload)
}

const getAllIcaNoPaginationRequest = function* ({ payload }) {
  yield call(newRequestFunction, getAllIcaNoPaginationSuccess, getAllIcaNoPaginationFailure, getAllIcaNoPaginationApi, payload)
}

// Watchers
const getAllRegisteredCmIcaWatcher = function* () {
  yield takeEvery(GET_ALL_REGISTERED_CM_ICA, getAllRegisteredCmIcaRequest)
}

const getCmIcaWatcher = function* () {
  yield takeEvery(GET_CM_ICA_BY_ID, getCmIcaRequest)
}

const exporCmTrainingtWatcher = function* () {
  yield takeEvery(EXPORT_CM_TRAINING, exportCmTrainingRequest)
}

const getAllIcaNoPaginationWatcher = function* () {
  yield takeEvery(GET_ALL_ICA_NO_PAGINATION, getAllIcaNoPaginationRequest)
}

export default function* rootSaga() {
  yield all([
    fork(getAllRegisteredCmIcaWatcher),
    fork(getCmIcaWatcher),
    fork(exporCmTrainingtWatcher),
    fork(getAllIcaNoPaginationWatcher),
  ])
}